import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
// import tmdbApi from "../../api/tmdbApi";
import apiConfig from '../../api/apiConfig';
import axios from 'axios';
import "./detail.scss"
import CastList from './CastList';
import VideoList from './VideoList';
import MovieList from "../../components/movie-list/MovieList";

const Detail = () => {
  const { category, id } = useParams();
  const [item, setItem] = useState(null);

  useEffect(() => {
    const getDetail = async () => {
      const response = await axios.get(`https://api.themoviedb.org/3/${category}/${id}?api_key=088f4df643022cbbe2a297babd84490c`);
      setItem(response.data);
      window.scrollTo(0, 0);
    }
    getDetail();
  }, [category, id]);
  return (
    <>
      {
        item && (
          <>
            <div
              className="banner"
              style={{ backgroundImage: `url(${apiConfig.originalImage(item.backdrop_path || item.poster_path)})` }}
            ></div>

            <div className="mb-3 movie-content container">
              <div className="movie-content__poster">
                <div
                  className="movie-content__poster__img"
                  style={{ backgroundImage: `url(${apiConfig.originalImage(item.poster_path || item.backdrop_path)})` }}></div>
              </div>
              <div className="movie-content__info">
                <h1 className="title">{item.title || item.name}</h1>
                <h2>{item.original_title}</h2>
                <h3>{item.spoken_languages[0].english_name}</h3>

                <div className="genres">
                  {
                    item.genres && item.genres.slice(0, 5).map((genre, index) => (
                      <span key={index} className='genres__item'>{genre.name}</span>
                    ))
                  }
                </div>

                <p className="overview">{item.overview}</p>

                {
                  category === 'movie' ? (
                    <div className="cast">
                      <div className="section__header">
                        <h2>Casts</h2>
                      </div>
                      <CastList id={item.id} />{console.log(item.id)}
                    </div>
                  ) : ""
                }

                {
                  category === 'tv' ? (
                    <div className="cast">
                      <div className="section__header">
                        <h2>Production Companies</h2>
                      </div>
                      <div className='casts'>
                        {
                          item.production_companies.map((company, index) => (
                            <div className="casts__item" key={index}>
                              <div className="productionImg" style={{ backgroundImage: `url(${apiConfig.w500Image(company.logo_path)})` }}></div>
                              <p className="casts__item__name">{company.name}</p>
                            </div>
                          ))
                        }
                      </div>
                    </div>
                  ) : ""
                }

              </div>
            </div>

            <div className="container">
              <div className="section mb-3">
                <VideoList id={item.id} />
              </div>

              <div className="section mb-3">
                <div className="section__header mb-2">
                  <h2>Similar</h2>
                </div>
                <MovieList category={category} type='similar' id={item.id} />
              </div>
            </div>
          </>
        )
      }
    </>
  )
}

export default Detail